import axios from "axios";

// Use same-origin in production (backend serves the frontend).
// Only use REACT_APP_BACKEND_URL in local dev where they run on different ports.
const BACKEND_URL =
  process.env.NODE_ENV === "development"
    ? (process.env.REACT_APP_BACKEND_URL || "")
    : "";
export const API = `${BACKEND_URL}/api`;

// All auth is via httpOnly cookies (auth_token for JWT, session_token for OAuth).
// We never read/write auth tokens from JavaScript — protects against XSS token theft.
export const api = axios.create({
  baseURL: API,
  withCredentials: true,
});

// Double-submit CSRF: the backend mints a non-httpOnly `csrf_token` cookie
// (deliberately readable by JS — see backend/shared/deps.py) and requires it
// echoed back as X-CSRF-Token on every unsafe-method request that relies on
// cookie auth (backend/server.py CSRFMiddleware). A cross-site attacker page
// can't read this cookie, so it can't forge a matching header.
function getCookie(name) {
  const match = document.cookie.match(
    new RegExp(`(?:^|; )${name}=([^;]*)`)
  );
  return match ? decodeURIComponent(match[1]) : null;
}

const CSRF_SAFE_METHODS = new Set(["get", "head", "options"]);

api.interceptors.request.use((config) => {
  const method = (config.method || "get").toLowerCase();
  if (!CSRF_SAFE_METHODS.has(method)) {
    const csrfToken = getCookie("csrf_token");
    if (csrfToken) {
      config.headers = config.headers || {};
      config.headers["X-CSRF-Token"] = csrfToken;
    }
  }
  return config;
});
